// Helpers for turning Markdown headings into anchor ids and a table-of-contents
// model. The same `slugifyHeading` is used both when rendering headings (to set
// their `id`) and when building the TOC, so in-page anchor links always match.

export interface DocsTocEntry {
  level: number;
  text: string;
  id: string;
}

// Lowercase, hyphenated, anchor-safe id derived from a heading's text.
export function slugifyHeading(text: string): string {
  return text
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// Extracts H2/H3 headings from a Markdown document, skipping fenced code blocks
// so that `#` inside code samples is not mistaken for a heading.
export function extractToc(markdown: string): DocsTocEntry[] {
  const entries: DocsTocEntry[] = [];
  let inFence = false;

  for (const line of markdown.split('\n')) {
    if (/^\s*(```|~~~)/.test(line)) {
      inFence = !inFence;
      continue;
    }
    if (inFence) continue;

    const match = /^(#{2,3})\s+(.*\S)\s*$/.exec(line);
    if (!match) continue;

    const text = match[2].replace(/#+\s*$/, '').trim();
    entries.push({ level: match[1].length, text, id: slugifyHeading(text) });
  }

  return entries;
}
